<template>
	<section class="app-presets">
		<h2 class="app-presets__title">
			{{ $t('presets') }} <span class="flag flag--base-font-color">{{ presets.length }}</span>
		</h2>

		
		<template v-if="presets.length">
			<ul
				class="app-presets__list"
				:class="{
					'app-presets__list--show-more': show_more_presets,
					'is-show-more': isShowMorePresets
				}"
			>
				<li class="app-presets__item" v-for="(preset, index) in presets" :key="'preset-' + preset.id + '-' + index">
					<article
						:class="[
							'app-presets-card',
							`app-presets-card--bg-${this.generateRandomNamber(9)}`,
							`app-presets-card--icon-${this.generateRandomNamber(22)}`,
							{
								'app-presets-card--brend': preset.is_private,
							}
						]"
					>
						<a :href="preset.url" class="app-presets-card__link">
							<h3 class="app-presets-card__title">{{ preset.name }}</h3>
							<div class="app-presets-card__bottom">
								<ul class="app-presets-card__list">
									<li class="app-presets-card__item">
										<div class="course-tag course-tag--bg-white">{{ $t('courses', preset.courses_count) }}</div>
									</li>
									<li v-if="preset.is_private" class="app-presets-card__item">
										<div class="course-tag course-tag--outline-white">{{ current_company_name }}</div>
									</li>
								</ul>
							</div>
						</a>
					</article>
				</li>
			</ul>

			<div v-if="show_more_presets && presets.length > 6" class="app-presets__bottom">
				<button @click="showPresets" class="app-btn app-btn--round app-btn--outline" type="button">
					{{ isShowMorePresets ? $t('buttons.show_less') : $t('buttons.show_more') }}
				</button>
			</div>
		</template>
	</section>
</template>

<script>
export default {
	name: "PresetSelection",

	components: {
	},

	props: {
		presets: Array,
		current_company_name: {
			type: String,
			default: ''
		},
		show_more_presets: {
			type: Boolean,
			default: true
		}
	},

	data() {
		return {
			loading: true,
			isShowMorePresets: false
		};
	},

	methods: {
		generateRandomNamber(limit) {
			return Math.floor(Math.random() * limit) + 1;
		},

		showPresets() {
			this.isShowMorePresets = !this.isShowMorePresets;
		}
	}
};
</script>
